var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col min-h-screen",attrs:{"id":"app"}},[_c('div',{staticClass:"grid grid-cols-12 min-h-screen"},[_c('div',{class:[
        _vm.getAuthLoggedIn && _vm.getSidebarOpen ? 'col-span-2' : 'hidden'
      ]},[_c('sidebar')],1),_c('div',{class:[
        _vm.getAuthLoggedIn
          ? _vm.getSidebarOpen
            ? 'col-span-10'
            : 'col-span-12'
          : 'col-span-12'
      ]},[(_vm.getCurrentRoute !== _vm.ROUTE_HEALTH())?_c('top-bar'):_vm._e(),_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }